import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import cogoToast from "cogo-toast";
import { BACKEND_URL } from "../../../constants";
import Input from "components/Input/Input";
import PublitioAPI from 'publitio_js_sdk'
import ButtonPrimary from "components/Button/ButtonPrimary";
import Heading2 from "components/Heading/Heading2";
import Datetime from 'react-datetime';
import 'moment/locale/pl';
import { 
  BtnBold,
  BtnBulletList,
  BtnClearFormatting,
  BtnItalic,
  EditorProvider,
  Editor,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  HtmlButton,
  Separator,
  Toolbar,
} from 'react-simple-wysiwyg';
import ClipLoader from "react-spinners/ClipLoader";
import "react-datetime/css/react-datetime.css";
import Layout from "../layout";


function ensurePublitioTransform(url, defaultTransform = "h_720") {
  try {
    const parsed = new URL(url);

    // Sprawdzamy czy link jest z Publitio
    if (!parsed.hostname.includes("publit.io")) return url;

    const pathParts = parsed.pathname.split("/").filter(Boolean);
    const fileIndex = pathParts.indexOf("file");

    // Jeżeli po "file" jest transformacja → zostaw
    if (
      fileIndex >= 0 &&
      pathParts[fileIndex + 1] &&
      pathParts[fileIndex + 1].match(/^[a-z]_\d+/)
    ) {
      return url;
    }

    // Dodaj domyślną transformację
    pathParts.splice(fileIndex + 1, 0, defaultTransform);
    parsed.pathname = "/" + pathParts.join("/");

    return parsed.toString();
  } catch (e) {
    console.error("Błędny URL Publitio:", e);
    return url;
  }
}

const PageDefaultLive = () => {
  const publitio = new PublitioAPI('m7RBc51bBSJtDLyfn5ox', 'D7e4hWupPLHs0wqpXQDNQy2kJ6vVQZWZ')
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  let user = sessionStorage.getItem("user")
  let userId = JSON.parse(user)?.user.id
  const {
    register,
    getValues,
    // formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      image: "",
      video: ""
    },
  });

  const addVideoLive = async (e) => {
    setLoading(true)
    const data = getValues();
    let photo;
    let video;
    e.preventDefault();
    photo = await publitio.uploadFile(data.image[0], 'file')
    video = await publitio.uploadFile(data.video[0], 'file')
    console.log("Video upload response", video, photo)
    cogoToast.info("Film został dodany do hostingu. Zaczynam dodawać artykuł")
    setTimeout(() => {
      fetch(`${BACKEND_URL}/addDefaultLive`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          video: ensurePublitioTransform(video.url_stream, "h_480"),
          image: photo?.url_preview
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.statusCode === 200) {
            setLoading(false)
            cogoToast.success("Artykuł został dodany");
            window.location.reload()
          }
          else if(response.statusCode === 400) {
            cogoToast.error("Wystąpił jakiś błąd");
          } 
        })
        .catch((error) => console.error("error: ", error));
    }, [2000]);
  };
  return (
    <Layout>
      <header className="text-center max-w-2xl mx-auto - mb-14 sm:mb-16 lg:mb-20 ">
        <Heading2>Dodaj domyślne wideo do live</Heading2>
        {/* <span className="block text-sm mt-2 text-neutral-700 sm:text-base dark:text-neutral-200">
         Witamy
        </span> */}
      </header>

      <div className="max-w-md mx-auto space-y-6">
        {/* FORM */}
        <form className="grid grid-cols-1 gap-6" action="#" method="post">
           
          <label className="block">Dodaj film
            <Input {...register("video", {
            })} type="file" max-size="200000" className="mt-1" />
          </label>
          <label className="block">Dodaj zdjęcie
            <Input {...register("image", {
            })} type="file" max-size="200000" className="mt-1" />
          </label>
        </form>
        <ButtonPrimary onClick={addVideoLive}>Dodaj</ButtonPrimary>
        {loading == true && 
        <div style={{marginTop:'40px'}}>
          <p style={{marginBottom:'20px'}}>Uwaga dodawanie filmu może chwile potrwać zależności od wielkości wysłanego pliku.</p>
          <ClipLoader color="black" size={50} aria-label="Loading Spinner" data-testid="loader"/>
          </div>}
      </div>
    </Layout>
  );
};

export default PageDefaultLive;